import { getLink } from "../../../NavUtils";

// full page path
export const getNavOrgAthlete = (athleteId: string) => `/org/athletes/${athleteId}`;
export const getNavOrgAthleteWithTeam = (athleteId: string, teamId: string) => `/org/teams/${teamId}/athletes/${athleteId}`;

// local child paths
export const NAV_ATHLETE_SUMMARY = "summary";
export const NAV_ATHLETE_MEAL_PLANS = "meal-plans";
export const NAV_ATHLETE_GOALS = "goals";
export const NAV_ATHLETE_FOOD_LOGS = "food-logs";
export const NAV_ATHLETE_ANTHROPOMETRY = "anthropometry";
export const NAV_ATHLETE_NOTES = "notes";
export const NAV_ATHLETE_ENERGY_EXPENDITURE = "energy-expenditure";

// full child paths
export const getNavOrgAthleteWithTeamSummary = (athleteId: string, teamId: string) => `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_SUMMARY}`;
export const getNavOrgAthleteWithTeamMealPlans = (athleteId: string, teamId: string) => `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_MEAL_PLANS}`;
export const getNavOrgAthleteWithTeamMealPlansMealPlan = (athleteId: string, teamId: string, mealPlanId: string) =>
  `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_MEAL_PLANS}/${mealPlanId}`;
export const getNavOrgAthleteWithTeamFoodLogs = (athleteId: string, teamId: string) => `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_FOOD_LOGS}`;
export const getNavOrgAthleteWithTeamAnthropometry = (athleteId: string, teamId: string) => `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_ANTHROPOMETRY}`;

export const getNavOrgAthleteLink = (athleteId: string, athleteName: string) => getLink(athleteName, getNavOrgAthlete(athleteId));
export const getNavOrgAthleteLinkWithTeam = (athleteId: string, athleteName: string, teamId: string) => getLink(athleteName, getNavOrgAthleteWithTeam(athleteId, teamId));

export const getNavOrgAthleteWithTeamGoalCompliance = (athleteId: string, teamId: string, goalConfigurationId: string) =>
  `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_GOALS}/${goalConfigurationId}`;

export const getNavOrgAthleteWithTeamGoal = (athleteId: string, teamId: string) =>
  `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_GOALS}`;

export const getNavOrgAthleteWithTeamEnergyExpenditure = (athleteId: string, teamId: string) =>
  `${getNavOrgAthleteWithTeam(athleteId, teamId)}/${NAV_ATHLETE_ENERGY_EXPENDITURE}`;